import React from "react";
import { useMedia } from "react-use";
import { config as cssConfig } from "@100mslive/roomkit-react";
import { NumbersIcon } from "../../icons";

const LandingHowItWork = () => {
  const isMobile = useMedia(cssConfig.media.md);
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-landing-howitwork">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-landing-section-header">
          <h2
            className={`events-page-landing-section-header-heading ${
              isMobile ? "text-center" : ""
            } `}
          >
            How It Works
          </h2>
        </div>
        <div className="events-page-landing-howitwork-content">
          <div className="events-page-landing-howitwork-content-item">
            <div className="events-page-landing-howitwork-content-item-icon">
              <NumbersIcon type="1" />
            </div>
            <div className="events-page-landing-howitwork-content-item-title">
              Launch Your Branded Community Hub
            </div>
            <div className="events-page-landing-howitwork-content-item-text">
              We create your custom-branded investor destination with your look
              and feel
            </div>
          </div>
          <div className="events-page-landing-howitwork-content-item">
            <div className="events-page-landing-howitwork-content-item-icon">
              <NumbersIcon type="2" />
            </div>
            <div className="events-page-landing-howitwork-content-item-title">
              Connect Directly With Shareholders
            </div>
            <div className="events-page-landing-howitwork-content-item-text">
              Host investor events, share updates, and answer questions in a
              compliant environment
            </div>
          </div>
          <div className="events-page-landing-howitwork-content-item">
            <div className="events-page-landing-howitwork-content-item-icon">
              <NumbersIcon type="3" />
            </div>
            <div className="events-page-landing-howitwork-content-item-title">
              Grow Your Investor Network
            </div>
            <div className="events-page-landing-howitwork-content-item-text">
              Our cross-discovery system introduces your company to qualified
              investors on the platform
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHowItWork;
